module.exports = __webpack_public_path__ + "static/img/15-北京市宣武回民小学1.0669ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/15-北京市宣武回民小学1.png
// module id = 72jg
// module chunks = 0